<template>
  <div class="modal micromodal-slide" aria-hidden="true" id="modal-1" :class="{ 'is-open': selectItem.open }">
    <div class="bg modal__overlay" v-on:click="closeItemDetail()"></div>
    <div class="modal_item modal_cart">
      <button v-on:click="closeItemDetail()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <div class="modal_wrap" ref="modal__content">
        <div class="item_wrap">
          <!-- <div class="item_image"><img v-bind:src="selectItem.image" :alt="selectItem.productName" v-on:error="imageError"></div> -->
          <div class="item_image"><img :src="selectItem.image" v-on:error="imageError" :data-noimage="selectItem.noImagePath" :alt="selectItem.productName"></div>
          <div class="item_contents">
            <h3 class="item_title ab c5a">{{ selectItem.productName }}</h3>
            <div class="price_wrap">
              <p class="item_price rb c5a"><span class="yen ab">￥</span>{{ selectItem.price.toLocaleString() }}</p>
              <p v-if="selectItem.point != 0" class="item_point rb c5a"><span class="point_text ab">ポイント：</span>{{ selectItem.point.toLocaleString() }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>
        <div class="manth_wrap">
          <div class="month_item">
            <p class="month ab c5a" v-if="selectItem.detail[0].month != 0"><span class="month_number rb">{{ selectItem.detail[0].month }}</span>月</p>
            <p class="month" style="border-bottom: none;" v-else></p>
            <div class="count_wrap">
              <span class="count ab c5a">数量</span>
              <div class="select_wrap">
                <select name="buy_count" id="" v-bind:data-count-id="'buyCount0'" class="select_count rb" v-model="selectItem.detail[0].count">
                  <option v-for="n of selectItem.maxCount + 1" :value="n - 1">{{ n - 1 }}</option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="selectItem.detail[1].month != 0" class="month_item">
            <p class="month ab c5a"><span class="month_number rb">{{ selectItem.detail[1].month }}</span>月</p>
            <div class="count_wrap">
              <span class="count ab c5a">数量</span>
              <div class="select_wrap">
                <select name="buy_count" id="" v-bind:data-count-id="'buyCount1'" class="select_count rb" v-model="selectItem.detail[1].count">
                  <option v-for="n of selectItem.maxCount + 1" :value="n - 1">{{ n - 1 }}</option>
                </select>
              </div>

            </div>
          </div>
        </div>
        <div v-if="selectItem.selectChildFund" class="kodomo_wrap">
          <input class="kodomo_check" type="checkbox" id="kodomo" name="checkbox01" v-model="child">
          <label for="kodomo" class="checkbox01 ab c5a kodomo_text">こども基金を支援する</label>
        </div>
        <button v-on:click="insertCart(selectItem)" class="btn_blue insert_btn" type="button" name="button">カートに入れる</button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config'

export default {
  props: ['selectItem'],
  data() {
    return {
      cartItem: [],
      child: false
    }
  },
  methods: {
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    closeItemDetail() {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.child = false;
      this.selectItem.detail[0].count = 0;
      this.selectItem.detail[1].count = 0;

      // 商品詳細閉じる
      this.$emit('detailClose', false);
    },
    insertCart(selectItem) {
      if (this.selectItem.detail[0].count == 0 && this.selectItem.detail[1].count == 0) {
        // 注文数が0の場合処理終了
        return false;
      }
      let nowBC = this.purchaseNowBC;
      let price = selectItem.price;

      let point = selectItem.point;
      let totalPrice = (price * this.selectItem.detail[0].count) + (price * this.selectItem.detail[1].count);
      let totalPoint = (point * this.selectItem.detail[0].count) + (point * this.selectItem.detail[1].count);
      if (this.child) {
        totalPrice = totalPrice + (100 * this.selectItem.detail[0].count) + (100 * this.selectItem.detail[1].count);
      }
      const data = {
        currentOrderMonth: this.purchaseCurrentOrderMonth,
        item: {
          image: selectItem.image,
          noImage: selectItem.noImagePath,
          title: selectItem.productName,
        },
        countItem: [
          { year: this.selectItem.detail[0].year, month: this.selectItem.detail[0].month, count: this.selectItem.detail[0].count },
          { year: this.selectItem.detail[1].year, month: this.selectItem.detail[1].month, count: this.selectItem.detail[1].count }
        ],
        productId: this.selectItem.productId,
        child: this.child,
        selectChildFund: this.selectItem.selectChildFund,
        itemPrice: price,
        itemPoint: point,
        price: totalPrice,
        point: totalPoint,
        genreId: this.selectItem.genreId,
        maxCount: this.selectItem.maxCount,
      };
      this.$store.commit('addCartCount', 1);
      // ストレージの商品とカートに追加する商品に同じものがあるか判定（bcと商品名の一致）
      const bcCart = JSON.parse(localStorage.getItem(nowBC));
      if (bcCart != null) {
        for (var i = 0; i < bcCart.length; i++) {
          if (data.item.title != bcCart[i].item.title) {
            this.cartItem.push(bcCart[i]);
          } else {
            this.$store.commit('subtractCartCount', 1);
          }
        }
      }
      this.cartItem.push(data);
      // // 配列をローカルストレージに保存する
      localStorage.setItem(nowBC, JSON.stringify(this.cartItem)); // JSONに変換
      // 個数とチェックボックスの値を初期化
      this.child = false;
      selectItem.detail[0].count = 0;
      selectItem.detail[1].count = 0;
      this.$emit('detailClose', false);
      this.$emit('addItem', data);// 親コンポーネントのwatchを発火

      this.cartItem.splice(0, this.cartItem.length);
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
    },
  },
  computed: mapGetters(['purchaseNowBC', 'purchaseCurrentOrderMonth']),
}
</script>

<style lang="css" scoped>
.modal_wrap {
  margin-top: 40px;
}
.modal_item .item_wrap {
  padding: 0 16px;
  width: 100%;
}
.modal_item.modal_cart {
  height: 95%;
}
.item_image {
  width: 40%;
}
.item_contents {
  width: 55%;
}

.item_price {
  font-size: 30px;
  margin-top: 16px;
}

.yen {
  font-size: 24px;
}

.item_point {
  font-size: 20px;
}

.point_text {
  font-size: 14px;
}

.point {
  font-size: 14px;
}

.manth_wrap {
  margin-top: 24px;
}

.month_item {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}

.month_item:not(:first-child) {
  margin-top: 19px;
}

.month {
  border-bottom: 1px solid  #c9c9c9;
  font-size: 18px;
  padding-left: 32px;
  position: relative;
  width: 64%;
}

.month::before {
  background-color: #4FCCD4;
  bottom: 0;
  content: '';
  height: 90%;
  left: 16px;
  margin: auto;
  position: absolute;
  top: 0;
  width: 8px;
}

.month_number {
  font-size: 30px;
  margin-right: 4px;
}

.count_wrap {
  align-items: center;
  display: flex;
  width: 35%;
}

.count {
  bottom: -6px;
  font-size: 14px;
  position: relative;
}
.select_wrap {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 2px;
  width: 60%;
}

.select_wrap::after {
  margin-right: 0;
  right: 0;
  top: 7px;
}

.select_count {
  /* border-bottom: 1px solid #5a5a5a; */
  color: #5A5A5A;
  display: block;
  font-size: 26px;
  /* padding-left: 15px; */
  margin-left: auto;
  text-align: left;
  width: 90%;
}

.kodomo_wrap {
  margin-top: 20px;
  text-align: center;
}


.item_detail .btn_blue {
  margin-top: 54px;
}


.item_title {
  font-size: 16px;
  display: flex;
  justify-content: flex-end;
}

.price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.buy_text {
  width: 60%;
}
.input_number {
  border: none;
  border-bottom: 1px solid #000;
  display: block;
  font-size: 26px;
  padding-right: 5px;
  text-align: right;
  width: 100%;
}
.insert_btn {
  margin-top: 20px;
}

.modal_item.modal_cart {
  padding: 16px;
}

.modal_item.modal_cart .scroll {
  margin-top: 40px;
  padding-bottom: 100px;
}

.kodomo_text {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/SelectItem.vue